import { masterMark } from '@deltasuite/ui-tokens';
import { QUOTES } from './quotes';

interface Props {
  quoteIndex: number;
  pointsScored: number;
  pointTarget: number;
  contactsTouched: number;
  totalContacts: number;
  onContinue: () => void;
  onSkip: () => void;
}

export function TransitionScreen(props: Props) {
  const quote = QUOTES[props.quoteIndex % QUOTES.length] ?? QUOTES[0]!;
  const safeTarget = Math.max(props.pointTarget, 1);
  const pct = Math.min(props.pointsScored / safeTarget, 1) * 100;

  return (
    <main className="flex min-h-full flex-col items-center justify-center px-8 py-16">
      <div className="w-full max-w-md text-center">
        <span className="font-sans text-3xl leading-none text-signal-amber" aria-hidden>
          {masterMark}
        </span>
        <p className="mt-8 font-sans text-2xl font-semibold leading-snug tracking-tight text-graphite-900">
          {quote}
        </p>
        <dl className="mt-12 grid grid-cols-3 gap-4 font-mono text-xs">
          <div>
            <dt className="text-graphite-500">points</dt>
            <dd className="mt-1 text-lg text-graphite-900">{props.pointsScored}</dd>
          </div>
          <div>
            <dt className="text-graphite-500">target</dt>
            <dd className="mt-1 text-lg text-graphite-900">{props.pointTarget}</dd>
          </div>
          <div>
            <dt className="text-graphite-500">touched</dt>
            <dd className="mt-1 text-lg text-graphite-900">
              {props.contactsTouched}/{props.totalContacts}
            </dd>
          </div>
        </dl>
        <div className="mt-6 h-1 w-full overflow-hidden rounded-full bg-graphite-100" aria-hidden>
          <div
            className="h-full bg-accent-progress transition-[width] duration-700 ease-out"
            style={{ width: `${pct}%` }}
          />
        </div>

        <div className="mt-10 flex justify-center gap-3">
          <button
            type="button"
            onClick={props.onSkip}
            className="rounded-md border border-graphite-300 px-4 py-2 font-sans text-sm text-graphite-700 hover:bg-surface-sunk"
          >
            Skip
          </button>
          <button
            type="button"
            onClick={props.onContinue}
            className="rounded-md bg-graphite-900 px-4 py-2 font-sans text-sm font-medium text-surface hover:bg-graphite-700"
          >
            Next contact
          </button>
        </div>
      </div>
    </main>
  );
}
